export default __webpack_public_path__ + "static/media/right.88c67387.svg";